import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl px-4 py-2 text-gray-400" }, "Money Transfers", -1)
const _hoisted_3 = { class: "flex items-center bg-gray-100 mx-4 my-2 px-4 py-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Status", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_8 = { class: "flex flex-col space-y-2 w-full p-8" }
const _hoisted_9 = {
  key: 0,
  class: "table-auto"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Users e-Mail"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Users Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Created"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Package"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Actions")
  ])
], -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "p-5" }, null, -1)
const _hoisted_27 = {
  key: 2,
  class: "flex space-x-6 border border-gray-200"
}
const _hoisted_28 = { class: "table-auto m-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Id", -1)
const _hoisted_30 = { class: "text-left pl-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Transfer Code", -1)
const _hoisted_32 = { class: "text-left pl-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Company", -1)
const _hoisted_34 = { class: "text-left pl-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Company Tax No", -1)
const _hoisted_36 = { class: "text-left pl-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Company Tax Office", -1)
const _hoisted_38 = { class: "text-left pl-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Citizenship No", -1)
const _hoisted_40 = { class: "text-left pl-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "City", -1)
const _hoisted_42 = { class: "text-left pl-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Country", -1)
const _hoisted_44 = { class: "text-left pl-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Address", -1)
const _hoisted_46 = { class: "text-left pl-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "First Name", -1)
const _hoisted_48 = { class: "text-left pl-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Last Name", -1)
const _hoisted_50 = { class: "text-left pl-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Zip Code", -1)
const _hoisted_52 = { class: "text-left pl-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Price", -1)
const _hoisted_54 = { class: "text-left pl-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "KDV", -1)
const _hoisted_56 = { class: "text-left pl-4" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Total", -1)
const _hoisted_58 = { class: "text-left pl-4" }
const _hoisted_59 = { class: "flex space-x-2 border-l border-gray-200" }
const _hoisted_60 = { class: "flex flex-col space-y-2 m-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.moneyTransferStatuses)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              class: "mt-1 outline-none block rounded px-2 py-1 ring-1 ring-gray-300 focus:ring-2 text-sm",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMoneyTransferStatus) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moneyTransferStatuses, (enumItem) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: enumItem.key,
                  value: enumItem.key
                }, _toDisplayString(enumItem.name), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedMoneyTransferStatus]
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn-one",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getReceiptToGenerate && _ctx.getReceiptToGenerate(...args)))
        }, "List")
      ])
    ]),
    _createElementVNode("input", {
      type: "file",
      id: "file",
      ref: "file",
      multiple: "",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFileUpload())),
      style: {"position":"absolute","top":"-500px"},
      accept: "application/pdf"
    }, null, 544),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.items)
        ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.moneyTransferId
                }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.moneyTransferId), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.userEMail), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.userDisplayName), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatDecimal(item.price) + " TL + " + _ctx.formatDecimal(item.priceKdv) + " TL KDV"), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.moneyTransferCreatedDate), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.purchasedPackageName ? item.purchasedPackageName : item.userLicenseCount + " Licenses"), 1),
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, _toDisplayString(item.moneyTransferStatusString), 1),
                  _hoisted_22,
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "btn-one",
                      onClick: ($event: any) => (_ctx.openDetails(item))
                    }, "Details", 8, _hoisted_24)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, "No Record.")),
      _hoisted_26,
      (_ctx.selectedItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("table", _hoisted_28, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.selectedItem.moneyTransferId), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_31,
                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.selectedItem.transferCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_33,
                  _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.selectedItem.receiptAddressCompanyName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_35,
                  _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.selectedItem.receiptAddressCompanyTaxNo), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_37,
                  _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.selectedItem.receiptAddressCompanyTaxOffice), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_39,
                  _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.selectedItem.receiptAddressCitizenshipNo), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_41,
                  _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.selectedItem.receiptAddressCityName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_43,
                  _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.selectedItem.receiptAddressCountry), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_45,
                  _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.selectedItem.receiptAddressAddress), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_47,
                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.selectedItem.receiptAddressPersonFirstName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_49,
                  _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.selectedItem.receiptAddressPersonLastName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_51,
                  _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.selectedItem.receiptAddressZipCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_53,
                  _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.formatDecimal(_ctx.selectedItem.price) + " TL"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_55,
                  _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.formatDecimal(_ctx.selectedItem.priceKdv) + " TL"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_57,
                  _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.formatDecimal(_ctx.selectedItem.price + _ctx.selectedItem.priceKdv) + " TL"), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Receipt No",
                  class: "input-one",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItem.receiptNumber) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.selectedItem.receiptNumber]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "Receipt Date",
                  class: "input-one",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItem.receiptPdfCreationDate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.selectedItem.receiptPdfCreationDate]
                ]),
                (_ctx.selectedItem.moneyTransferStatus === _ctx.MoneyTransferStatusEnum.Created)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-one",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
                    }, "Approve"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Decline Reason",
                  class: "input-one",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItem.description) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.selectedItem.description]
                ]),
                (_ctx.selectedItem.moneyTransferStatus === _ctx.MoneyTransferStatusEnum.Created)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn-one",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args)))
                    }, "Decline"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}